import Ban from '@/views/Ban.vue'
import ForgottenPassword from '@/views/ForgottenPassword.vue'
import Login from '@/views/Login.vue'
import Logout from '@/views/Logout.vue'
import NotFound from '@/views/NotFound.vue'
import Signup from '@/views/Signup.vue'

// --- lazy import ---
const AccountHandover = () => import('@/views/AccountHandover.vue')
const Ask = () => import('@/views/Ask.vue')
const BlockList = () => import('@/views/BlockList.vue')
const Call = () => import('@/views/Call.vue')
const CallLog = () => import('@/views/CallLog.vue')
const CallWaitingSetting = () => import('@/views/CallWaitingSetting.vue')
const Chat = () => import('@/views/Chat.vue')
const EmailAuthentication = () => import('@/views/EmailAuthentication.vue')
const EmailSetting = () => import('@/views/EmailSetting.vue')
const FavList = () => import('@/views/FavList.vue')
const FootprintList = () => import('@/views/FootprintList.vue')
const Gift = () => import('@/views/Gift.vue')
const Home = () => import('@/views/Home.vue')
const Message = () => import('@/views/Message.vue')
const MessageFileGallery = () => import('@/views/MessageFileGallery.vue')
const MessageTemplate = () => import('@/views/MessageTemplate.vue')
const MessageTemplateEdit = () => import('@/views/MessageTemplateEdit.vue')
const Mypage = () => import('@/views/Mypage.vue')
const Notice = () => import('@/views/Notice.vue')
const NotificationSetting = () => import('@/views/NotificationSetting.vue')
const ProfileEdit = () => import('@/views/ProfileEdit.vue')
const ProfileEditImage = () => import('@/views/ProfileEditImage.vue')
const Report = () => import('@/views/Report.vue')
const Search = () => import('@/views/Search.vue')
const SearchName = () => import('@/views/SearchName.vue')
const Select = () => import('@/views/Select.vue')
const StorePayment = () => import('@/views/StorePayment.vue')
const Taikai = () => import('@/views/Taikai.vue')
const Timeline = () => import('@/views/Timeline.vue')
const TimelineDetail = () => import('@/views/TimelineDetail.vue')
const TimelineIine = () => import('@/views/TimelineIine.vue')
const TimelinePost = () => import('@/views/TimelinePost.vue')
const User = () => import('@/views/User.vue')

export default [
  // --- ログイン不要 ---
  {
    path: '*',
    redirect: { name: 'NotFound' }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/ask',
    name: 'ask',
    component: Ask
  },
  {
    path: '/ban',
    name: 'ban',
    component: Ban
  },
  {
    path: '/forgotten-password',
    name: 'forgotten-password',
    component: ForgottenPassword
  },
  {
    path: '/login/:id?/:password?',
    name: 'login',
    component: Login
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout
  },
  {
    path: '/signup',
    name: 'signup',
    component: Signup
  },
  // --- ログイン必須 ---
  {
    path: '/select/:type?',
    name: 'select',
    meta: {
      requiresAuth: true
    },
    component: Select
  },
  {
    path: '/(home)?',
    name: 'home',
    component: Home,
    meta: {
      basePage: true,
      requiresAuth: true
    }
  },
  {
    path: '/account/handover',
    name: 'account/handover',
    meta: {
      requiresAuth: true
    },
    component: AccountHandover
  },
  {
    path: '/blocklist',
    name: 'blocklist',
    meta: {
      requiresAuth: true
    },
    component: BlockList
  },
  {
    path: '/call/log',
    name: 'call/log',
    meta: {
      requiresAuth: true
    },
    component: CallLog
  },
  {
    path: '/call/waiting/setting',
    name: 'call/waiting/setting',
    meta: {
      requiresAuth: true
    },
    component: CallWaitingSetting
  },
  {
    path: '/call/:type/:makecall?',
    name: 'call',
    meta: {
      requiresAuth: true
    },
    component: Call
  },
  {
    path: '/favlist',
    name: 'favlist',
    meta: {
      requiresAuth: true
    },
    component: FavList
  },
  {
    path: '/message',
    name: 'message',
    component: Message,
    meta: {
      basePage: true,
      requiresAuth: true
    }
  },
  {
    path: '/message/:id/gallery',
    name: 'mfgallery',
    meta: {
      requiresAuth: true
    },
    component: MessageFileGallery
  },
  {
    path: '/message/:id/gift',
    name: 'gift',
    meta: {
      requiresAuth: true
    },
    component: Gift
  },
  {
    path: '/message/template/',
    name: 'mtemplate',
    meta: {
      requiresAuth: true
    },
    component: MessageTemplate
  },
  {
    path: '/message/template/edit/:template_id?',
    name: 'mtemplate_edit',
    meta: {
      requiresAuth: true
    },
    component: MessageTemplateEdit
  },
  {
    path: '/message/:id(\\d+)/:from?',
    name: 'chat',
    meta: {
      requiresAuth: true
    },
    component: Chat
  },
  {
    path: '/footprint/list/:type?',
    name: 'footprint/list',
    component: FootprintList,
    meta: {
      basePage: true,
      requiresAuth: true
    }
  },
  {
    path: '/mypage',
    name: 'mypage',
    component: Mypage,
    meta: {
      basePage: true,
      requiresAuth: true
    }
  },
  {
    path: '/notice/:type?/:no?',
    name: 'notice',
    meta: {
      requiresAuth: true
    },
    component: Notice
  },
  {
    path: '/notification/setting/email/:pin',
    name: 'notification/setting/email',
    meta: {
      requiresAuth: true
    },
    component: EmailSetting
  },
  {
    path: '/notification/setting/email/auth',
    name: 'notification/setting/email/auth',
    meta: {
      requiresAuth: true
    },
    component: EmailAuthentication
  },
  {
    path: '/notification/setting',
    name: 'notification/setting',
    meta: {
      requiresAuth: true
    },
    component: NotificationSetting
  },
  {
    path: '/buy/store',
    name: 'buy/store',
    meta: {
      requiresAuth: true
    },
    component: StorePayment
  },
  {
    path: '/profile/edit',
    name: 'profile/edit',
    meta: {
      requiresAuth: true
    },
    component: ProfileEdit
  },
  {
    path: '/profile/edit/image',
    name: 'profile/edit/image',
    meta: {
      requiresAuth: true
    },
    component: ProfileEditImage
  },
  {
    path: '/report/:id?',
    name: 'report',
    meta: {
      requiresAuth: true
    },
    component: Report
  },
  {
    path: '/search/name',
    name: 'search/name',
    meta: {
      requiresAuth: true
    },
    component: SearchName
  },
  {
    path: '/search',
    name: 'search',
    meta: {
      requiresAuth: true
    },
    component: Search
  },
  {
    path: '/taikai',
    name: 'taikai',
    meta: {
      requiresAuth: true
    },
    component: Taikai
  },
  {
    path: '/timeline',
    name: 'timeline',
    component: Timeline,
    meta: {
      basePage: true,
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/timeline/user/:user_id(\\d+)/:name',
    name: 'timeline/user',
    component: Timeline,
    meta: {
      basePage: true,
      requiresAuth: true
    }
  },
  {
    path: '/timeline/:user_id(\\d+)/:t_id',
    name: 'timeline/detail',
    component: TimelineDetail,
    meta: {
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/timeline/:user_id/:t_id/iine',
    name: 'timeline/iine',
    component: TimelineIine,
    meta: {
      requiresAuth: true
    },
    props: true
  },
  {
    path: '/timeline/post/:rejected?',
    name: 'timeline/post',
    meta: {
      requiresAuth: true
    },
    component: TimelinePost
  },
  {
    path: '/user/:id/:checkingMyProfile?',
    name: 'user',
    meta: {
      requiresAuth: true
    },
    component: User
  }
]
